import * as React from "react";
import {Tabs} from "shared/controls/Tabs/Tabs";
import {ToastService} from "shared/utilities/services/ToastService";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {SectionOptionsEnum} from "InternalShared/PageBuilder/Services/DragDropService";
import {GroupManager} from "InternalShared/PageBuilder/DragAndDrop/GroupManager";


export class GroupPanel extends React.Component<GroupPanelProps, GroupPanelState> {
    static defaultProps: Partial<GroupPanelProps> = {};
    private OriginalPositions:{Item:PDFControlBase,Position:{top:string,left:string},Section:SectionOptionsEnum}[]=[];
    constructor(props: GroupPanelProps) {
        super(props);
        this.state = {
            DisableUndoButton:true
        };
    }

    componentDidMount(): void {
        this.SaveOriginalPositions();
    }

    private SaveOriginalPositions() {
        this.OriginalPositions=[];
        for(let component of GroupManager.Current.SelectedElements)
        {

            this.OriginalPositions.push({
                Item:component,
                Section:component.Options.TargetId,
                Position:{
                    top:component.Options.Styles.Top,
                    left:component.Options.Styles.Left
                }
            })
        }
    }

    public render() {
        return (
            <Tabs>
                <Tabs.Item Title={'Aligment Options'} style={{backgroundColor:'white'}}>
                    <div>
                        <h4 style={{margin:0}}>Vertical Alignment</h4>
                        <button onClick={e=>this.AlignSelectedItems('left')} className={'rnbtn rnbtn-light'} style={{width:70,height:70,border:'1px solid #dfdfdf'}}>
                            <img style={{width:'100%'}} src={rednaoVar.URL+'images/alignment/align_left.svg'}/>
                        </button>
                        <button onClick={e=>this.AlignSelectedItems('center_vertical')}  className={'rnbtn rnbtn-light'} style={{width:70,height:70,border:'1px solid #dfdfdf'}}>
                            <img style={{width:'100%'}} src={rednaoVar.URL+'images/alignment/align_center_vertical.svg'}/>
                        </button>
                        <button onClick={e=>this.AlignSelectedItems('right')}  className={'rnbtn rnbtn-light'} style={{width:70,height:70,border:'1px solid #dfdfdf'}}>
                            <img style={{width:'100%'}} src={rednaoVar.URL+'images/alignment/align_right.svg'}/>
                        </button>
                    </div>
                    <div style={{marginTop:20}}>
                        <h4 style={{margin:0}}>Horizontal Alignment</h4>
                        <button onClick={e=>this.AlignSelectedItems('top')}  className={'rnbtn rnbtn-light'} style={{width:70,height:70,border:'1px solid #dfdfdf'}}>
                            <img style={{width:'100%'}} src={rednaoVar.URL+'images/alignment/align_top.svg'}/>
                        </button>
                        <button onClick={e=>this.AlignSelectedItems('center_horizontal')}  className={'rnbtn rnbtn-light'} style={{width:70,height:70,border:'1px solid #dfdfdf'}}>
                            <img style={{width:'100%'}} src={rednaoVar.URL+'images/alignment/align_center_horizontal.svg'}/>
                        </button>
                        <button onClick={e=>this.AlignSelectedItems('bottom')}  className={'rnbtn rnbtn-light'} style={{width:70,height:70,border:'1px solid #dfdfdf'}}>
                            <img style={{width:'100%'}} src={rednaoVar.URL+'images/alignment/align_bottom.svg'}/>
                        </button>
                    </div>

                    <div style={{marginTop:20}}>
                        <button onClick={e=>this.UndoAlignment()} className={'rnbtn rnbtn-primary'} disabled={this.state.DisableUndoButton}>Restore previous alignment</button>
                    </div>
                </Tabs.Item>
            </Tabs>
        )
    }

    private AlignSelectedItems(direction: string) {
        this.setState({
            DisableUndoButton:false
        })
        switch(direction)
        {
            case "top":
                if(GroupManager.Current.ElementOfDifferentSectionsWhereSelected())
                {
                    ToastService.SendErrorMessage('Sorry items of different sections (Header, Content or Footer) can NOT be horizontally aligned');
                    return;
                }
                let topToUse=GroupManager.Current.SelectedElements.reduce((previousValue:any, currentValue) => {return previousValue==null?currentValue.GetRelativeTop():Math.min(previousValue,currentValue.GetRelativeTop())},null);
                GroupManager.Current.SelectedElements.forEach(x=>{x.MoveTo(null,topToUse+'px')});
                break;
            case "bottom":
                if(GroupManager.Current.ElementOfDifferentSectionsWhereSelected())
                {
                    ToastService.SendErrorMessage('Sorry items of different sections (Header, Content or Footer) can NOT be horizontally aligned');
                    return;
                }
                let bottomToUse=GroupManager.Current.SelectedElements.reduce((previousValue:any, currentValue) => {return previousValue==null?currentValue.GetRelativeBottom():Math.max(previousValue,currentValue.GetRelativeBottom())},null);
                GroupManager.Current.SelectedElements.forEach(x=>{x.MoveTo(null,(bottomToUse-x.$element[0].getBoundingClientRect().height)+'px')});
                break;
            case "center_horizontal":
                if(GroupManager.Current.ElementOfDifferentSectionsWhereSelected())
                {
                    ToastService.SendErrorMessage('Sorry items of different sections (Header, Content or Footer) can NOT be horizontally aligned');
                    return;
                }

                let minimunPositionHorizontal=GroupManager.Current.SelectedElements.reduce((previousValue:any, currentValue) => {return previousValue==null?currentValue.GetRelativeTop():Math.min(previousValue,currentValue.GetRelativeTop())},null);
                let maxPositionHorizontal=GroupManager.Current.SelectedElements.reduce((previousValue:any, currentValue) => {return previousValue==null?currentValue.GetRelativeBottom():Math.max(previousValue,currentValue.GetRelativeBottom())},null);
                let centerHorizontal=(maxPositionHorizontal-minimunPositionHorizontal)/2+minimunPositionHorizontal;
                GroupManager.Current.SelectedElements.forEach(x=>{x.MoveTo(null,(centerHorizontal-(x.$element[0].getBoundingClientRect().height/2))+'px')});
                break;
            case "left":
                let leftToUse=GroupManager.Current.SelectedElements.reduce((previousValue:any, currentValue) => {return previousValue==null?currentValue.GetRelativeLeft():Math.min(previousValue,currentValue.GetRelativeLeft())},null);
                GroupManager.Current.SelectedElements.forEach(x=>{x.MoveTo(leftToUse+'px')});
                break;
            case "right":
                let rightToUse=GroupManager.Current.SelectedElements.reduce((previousValue:any, currentValue) => {return previousValue==null?currentValue.GetRelativeRight():Math.max(previousValue,currentValue.GetRelativeRight())},null);
                GroupManager.Current.SelectedElements.forEach(x=>{x.MoveTo((rightToUse-x.$element[0].getBoundingClientRect().width)+'px')});
                break;
            case "center_vertical":
                let minimunPositionVertial=GroupManager.Current.SelectedElements.reduce((previousValue:any, currentValue) => {return previousValue==null?currentValue.GetRelativeLeft():Math.min(previousValue,currentValue.GetRelativeLeft())},null);
                let maxPositionVertical=GroupManager.Current.SelectedElements.reduce((previousValue:any, currentValue) => {return previousValue==null?currentValue.GetRelativeRight():Math.max(previousValue,currentValue.GetRelativeRight())},null);
                let centerVertical=(maxPositionVertical-minimunPositionVertial)/2+minimunPositionVertial;
                GroupManager.Current.SelectedElements.forEach(x=>{x.MoveTo((centerVertical-(x.$element[0].getBoundingClientRect().width/2))+'px')});
                break;

        }


    }

    private UndoAlignment() {
        this.OriginalPositions.forEach(x=>{
            x.Item.MoveTo(x.Position.left,x.Position.top)
        });
        this.setState({DisableUndoButton:true})
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface GroupPanelProps {

}

interface GroupPanelState {
    DisableUndoButton:boolean;
}

//#endregion "My Region"